import { Col, DatePicker, Form, Select } from "antd";
import { useEffect, useState } from "react";
import {
  EXISTING_PO_MAP_LIST,
  GET_DIGITALIZATION_STYLES,
  PO_MAP_NEW_ENDPOINT,
  SEWING_LINES,
} from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import { isArrayAndHasValue } from "../../../utils/functions";
import CustomDatePicker from "common/CustomDatePicker";

const PackingFoldingToPackingFilter = ({ initialTableData }) => {
  // States
  const [sewingList, setSewingList] = useState([]);
  const [buyersList, setBuyersList] = useState([]);
  const [stylesList, setStylesList] = useState([]);
  const [poList, setPOList] = useState([]);

  // Antd
  const { Option } = Select;

  const getSewingList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 10,
      ...filterValues,
    };
    const response = await getData(SEWING_LINES, false, bodyData);

    if (response && response?.data?.code === 200) {
      setSewingList(response?.data?.data?.data || []);
    }
  };

  const getBuyersList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 10,
      ...filterValues,
    };
    const response = await getData(
      "/api/digitalization/buyers",
      false,
      bodyData,
    );

    if (response && response?.data?.code === 200) {
      const buyers =
        response?.data?.data?.data?.map((buyer) => ({
          id: buyer.id,
          name: buyer.name,
        })) || [];
      setBuyersList(buyers);
    }
  };

  const getStyleList = async (filterValues = {}) => {
    const bodyData = {
      per_page: filterValues?.per_page || 10,
      ...filterValues,
    };
    const response = await getData(GET_DIGITALIZATION_STYLES, false, bodyData);

    if (response && response?.data?.code === 200) {
      const styles =
        response?.data?.data?.data?.map((style) => ({
          id: style.id,
          name: style.style_no,
        })) || [];
      setStylesList(styles);
    }
  };

  const getPOList = async (value = null) => {
    let query = `${EXISTING_PO_MAP_LIST}`;
    if (value) {
      query = `${query}?po_map_id=${value}`;
    }
    const response = await getData(query);

    if (response && response?.data?.code === 200) {
      setPOList(response?.data?.data);
    }
  };

  // Effects
  useEffect(() => {
    getSewingList();
    getBuyersList();
    getStyleList();
    getPOList();
  }, []);

  return (
    <>
      <Col span={4}>
        <Form.Item label="Line" name="line_id">
          <Select
            showSearch
            allowClear
            placeholder="Select a Line"
            onSearch={(value) => {
              getSewingList({ name: value });
            }}
            optionFilterProp="children"
            size="small"
            filterOption={false}
          >
            {isArrayAndHasValue(sewingList) &&
              sewingList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={4}>
        <Form.Item label="Style" name="style_id">
          <Select
            showSearch
            allowClear
            placeholder="Select Style"
            filterOption={false}
            size="small"
            onSearch={(value) => {
              getStyleList({ style_no: value });
            }}
            onClear={() => getStyleList()}
          >
            {isArrayAndHasValue(stylesList) &&
              stylesList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={4}>
        <Form.Item label="Original PO" name="po_map_id">
          <Select
            showSearch
            placeholder="Select an original PO"
            onSearch={(value) => {
              getPOList({ original_po: value });
            }}
            optionFilterProp="children"
            size="small"
            allowClear
            onClear={() => getPOList()}
          >
            {isArrayAndHasValue(poList) &&
              poList.map((po) => (
                <Option value={po.id} key={po.id}>
                  {po.original_po}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default PackingFoldingToPackingFilter;
